import { Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { BaseText } from '../../../translation';
import { PeriodTypeService } from '../../../user/core';
import { currentBuilderState } from '../builder.state';

export function loadPeriodTypes(): Observable<void> {
    const periodTypeService =
        epicDependencies.injector.get<PeriodTypeService>(PeriodTypeService);

    return periodTypeService.list().pipe(
        catchErrorLogRet([]),
        tap((ret) => {
            _loadPeriodTypes(ret);
        }),
        mapTo(null),
    );
}

function _loadPeriodTypes(ret: BaseText[]): void {
    const state = currentBuilderState();

    ret.sort((a, b) => a.id - b.id);

    state.periodTypes = ret;
}
